// Celý build-style/style.css má 147 kB a inlinuje se do hlavičky každé
// stránky, přitom redakce používá hrstku bloků. Tahle sada pokrývá bloky
// nalezené v obsahu plus ty, po kterých editor běžně sáhne. Když se objeví
// nový blok bez stylů, stačí sem přidat další řádek.
import "@wordpress/block-library/build-style/paragraph/style.css";
import "@wordpress/block-library/build-style/heading/style.css";
import "@wordpress/block-library/build-style/list/style.css";
import "@wordpress/block-library/build-style/image/style.css";
import "@wordpress/block-library/build-style/gallery/style.css";
import "@wordpress/block-library/build-style/quote/style.css";
import "@wordpress/block-library/build-style/pullquote/style.css";
import "@wordpress/block-library/build-style/separator/style.css";
import "@wordpress/block-library/build-style/group/style.css";
import "@wordpress/block-library/build-style/columns/style.css";
import "@wordpress/block-library/build-style/button/style.css";
import "@wordpress/block-library/build-style/buttons/style.css";
import "@wordpress/block-library/build-style/table/style.css";
import "@wordpress/block-library/build-style/media-text/style.css";
import "@wordpress/block-library/build-style/embed/style.css";
import "@wordpress/block-library/build-style/video/style.css";
import "./src/styles/global.scss";

import { captureTrackingParams } from "./src/utils/trackingParams";

export const onClientEntry = () => {
  captureTrackingParams();
};
